'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { Children, cloneElement, isValidElement } from 'react';
import { FloatingLabelContextProvider } from '../../contexts/internal/floating-label/index.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(t, e) {
    if (null == t) return {};
    var o, r, l = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);
        for(r = 0; r < i.length; r++)o = i[r], !(e.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(t, o) && (l[o] = t[o]);
    }
    return l;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var o, r, l = {}, i = Object.keys(t);
    for(r = 0; r < i.length; r++)o = i[r], e.indexOf(o) >= 0 || (l[o] = t[o]);
    return l;
}
let s = {
    fullWidth: t.bool
};
const ListboxWithFloatingLabel = renderWithRef('ListboxWithFloatingLabel', s, (e, n)=>{
    let { fullWidth: s = false, children: p } = e, c = _object_without_properties(e, [
        "fullWidth",
        "children"
    ]), f = new Set([
        'swan-vanilla-ignore',
        'swan-listbox-with-floating-label'
    ]);
    return s && f.add("swan-listbox-with-floating-label-full-width"), jsx(FloatingLabelContextProvider, {
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: n,
            props: c,
            classNames: f,
            children: Children.map(p, (t, e)=>0 === e && isValidElement(t) ? cloneElement(t, {
                    fullWidth: null != s ? s : void 0
                }) : t)
        })
    });
});

export { ListboxWithFloatingLabel };
